import React from "react";
import ReactDOM from "react-dom";
import { BaseProvider, createDarkTheme } from "baseui";
import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";

import "./index.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assets/font-awesome/css/all.css";

const engine = new Styletron();
const baseUiGoldTheme = createDarkTheme({
  primaryA: "#F3EFE6",
  primaryB: "#0B0C0E",
  primary: "#F3EFE6",
  accent: "#C6A15B",
  accent50: "#1D1A14",
  accent100: "#2A2418",
  accent200: "#4B3C22",
  accent300: "#6E552E",
  accent400: "#92723A",
  accent500: "#C6A15B",
  accent600: "#D5B976",
  accent700: "#E4D19A",
  mono600: "#2A2B2D",
  mono700: "#1D1F22",
  mono800: "#15171A",
  mono900: "#0B0C0E",
  mono1000: "#050506",
});

ReactDOM.render(
  <StyletronProvider value={engine}>
    <BaseProvider theme={baseUiGoldTheme}>
      <App />
    </BaseProvider>
  </StyletronProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
